var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notaries__header"},[_c('img',{staticClass:"ui left medium image",attrs:{"src":require("@/assets/img/logo-formulariodenotarios-01.png")}})])
}]

export { render, staticRenderFns }